function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#iconApp2_svg__filter0_i)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.305 36.01L10.65 30v12l10.656-5.989z",
  fill: "#BDE0F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.97 30.014l-10.657-6.005v12.002l10.656-5.997z",
  fill: "#204E86"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.649 29.999l10.656 6.012V24.002L10.65 30z",
  fill: "#337AC8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.977 18.013l10.656 6.004v-12l-10.656 5.996z",
  fill: "#204E86"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.32 12.001l10.657 6.012V6.012l-10.657 5.99z",
  fill: "#BDE0F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.649 12.016L31.992 6.004v12.009l10.657-5.997z",
  fill: "#337AC8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.664 5.967l10.656 6.004V0L10.664 5.967z",
  fill: "#204E86"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 11.986l10.656 6.012V5.967L0 11.987z",
  fill: "#BDE0F7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.32 12.001L10.664 5.967v12.03l10.656-5.996z",
  fill: "#337AC8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.97 30.014l10.656 6.012V24.017l-10.657 5.997z",
  fill: "#BDE0F7"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "iconApp2_svg__filter0_i",
  x: 0,
  y: 0,
  width: 42.649,
  height: 45,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow"
})));

function SvgIconApp2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgIconApp2 as ReactComponent };